import { useAuth } from '../pages/login/OAuth';

const useOrderService = () => {
    const { api } = useAuth();

    const getOrder = (id) =>
        api().get(`/orders/${id}`);

    const getOrders = (params) =>
        api().get('/orders/', { params });

    const createOrder = (data) =>
        api().post('/orders/new', data);

    const updateOrder = (data) =>
        api().patch('/orders/', data);

    const createDeliveryNoteFromOrder = (data) =>
        api().post('/orders/dn_order', data);

    const addBuildingToOrder = (data) =>
        api().patch('/orders/add_building', data);

    const disableOrder = (id) =>
        api().patch('/orders/disable', { order_id: id });

    const disableDeliveryNoteFromOrder = (id) =>
        api().patch('/orders/disable_dn', { delivery_note_id: id });

    const getOrderPdf = (id) =>
        api().get(`/orders/${id}/generate-pdf`, { responseType: 'blob' });

    return {
        getOrder,
        getOrders,
        createOrder,
        updateOrder,
        createDeliveryNoteFromOrder,
        addBuildingToOrder,
        disableOrder,
        disableDeliveryNoteFromOrder,
        getOrderPdf,
    };
};

export default useOrderService;
